import ClearIcon from '@mui/icons-material/Clear';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import React from 'react';
import { WidgetEvents, postToParent } from '../../utils';

const Root = styled('div')`
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 70px;
  padding: 10px;
  background-color: #fff;
  display: flex;
  justify-content: center;
`;

const FRAME_ID = 'tic-sticky-button';

const StickyButton = ({ data, onOkClick, onClose, completion }) => {
  const { title, buttonText, socialProof } = data;

  const handleOkClick = () => {
    if (onOkClick) {
      onOkClick();
    } else {
      postToParent(WidgetEvents.LauncherButtonClick);
    }
  };

  const handleClose = (e) => {
    e.stopPropagation();
    if (onClose) {
      onClose();
    } else {
      postToParent(WidgetEvents.StickyButtonClose);
    }
  };

  return (
    <Root onClick={handleOkClick}>
      <Stack direction="row" alignItems="center" flex={1}>
        {socialProof && (
          <Box
            bgcolor="primary.main"
            color="primary.contrastText"
            borderRadius={2}
            p={1}
            minWidth={40}
            minHeight={40}
            textAlign="center"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
          >
            <Typography variant="h4" lineHeight={1} fontWeight={400}>
              {completion}
            </Typography>
          </Box>
        )}
        <Stack ml={2}>
          <Typography
            gutterBottom
            color="text.primary"
            variant="subtitle1"
            fontWeight={700}
            lineHeight={1.2}
          >
            {title}
          </Typography>
          <Typography
            variant="caption"
            fontWeight={500}
            color="text.secondary"
            lineHeight={1}
          >
            {buttonText}
          </Typography>
        </Stack>
      </Stack>
      <Box display="flex" alignItems="center">
        <IconButton variant="text" onClick={handleClose}>
          <ClearIcon />
        </IconButton>
      </Box>
    </Root>
  );
};

StickyButton.displayName = 'StickyButton';

export default StickyButton;
